import { render, staticRenderFns } from "./ShowMoreProducts.vue?vue&type=template&id=1af9f825&scoped=true"
import script from "./ShowMoreProducts.vue?vue&type=script&lang=js"
export * from "./ShowMoreProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af9f825",
  null
  
)

export default component.exports